import { Phase, Category, Task, TaskType, TaskStatus } from './types';

export const TASK_TYPE = {
  selfcheck: "selfcheck",
  file: 'file',
  jump: 'jump',
  tip: 'tip',
  dds: 'dds',
}

export const PHASES: Phase[] = [
  { id: 'p1', name: '前期准备', order: 1 },
  { id: 'p2', name: '规划、概念方案', order: 2 },
  { id: 'p3', name: '报批阶段', order: 3 },
  { id: 'p4', name: '初步设计', order: 4 },
  { id: 'p5', name: '施工图', order: 5 },
  { id: 'p6', name: '后期服务', order: 6 },
];

export const CATEGORIES: Category[] = [
  { id: 'c1', name: '计划及控制' },
  { id: 'c2', name: '合同及收费' },
  { id: 'c3', name: '会议策划及组织' },
  { id: 'c4', name: '业主需求分析' },
  { id: 'c5', name: '政府报批征询' },
  { id: 'c6', name: '技术征询' },
  { id: 'c7', name: '输入条件' },
  { id: 'c8', name: '风险控制' },
  { id: 'c9', name: '变更管理' },
  { id: 'c10', name: '遗留问题' },
];

export const INITIAL_TASKS: Task[] = [
  // Phase 1 - Planning
  {
    id: 't1',
    phaseId: 'p1',
    categoryId: 'c1',
    title: '确定项目等级',
    type: TaskType.SYSTEM,
    status: TaskStatus.COMPLETED,
    dueDate: '2025-03-12',
    description: '系统根据项目基本信息自动判定'
  },
  {
    id: 't2',
    phaseId: 'p1',
    categoryId: 'c1',
    title: '制定、更新项目通讯录',
    type: TaskType.ACTION,
    status: TaskStatus.WARNING,
    dueDate: '2025-03-20',
    warningMessage: '通讯录尚未提交，请尽快完成'
  },
  {
    id: 't3',
    phaseId: 'p1',
    categoryId: 'c1',
    title: '使用PLM进行项目管理',
    type: TaskType.SYSTEM,
    status: TaskStatus.PENDING,
    description: '等待PLM项目立项数据同步'
  },
  {
    id: 't4',
    phaseId: 'p1',
    categoryId: 'c1',
    title: '统一会议纪要格式',
    type: TaskType.MANUAL,
    status: TaskStatus.PENDING,
    description: '下载模板并分发给各专业负责人'
  },
  {
    id: 't5',
    phaseId: 'p1',
    categoryId: 'c1',
    title: '制定本阶段进度（周）计划',
    type: TaskType.ACTION,
    status: TaskStatus.PENDING,
    dueDate: '2025-04-01'
  },
  {
    id: 't6',
    phaseId: 'p1',
    categoryId: 'c2',
    title: '合同用印申请',
    type: TaskType.ACTION,
    status: TaskStatus.COMPLETED,
    dueDate: '2025-02-15'
  },
  // Phase 2 - Concept
  {
    id: 't7',
    phaseId: 'p2',
    categoryId: 'c1',
    title: '概念方案汇报PPT归档',
    type: TaskType.ACTION,
    status: TaskStatus.PENDING,
  }
];